import script from "./Partners.vue?vue&type=script&setup=true&lang=js"
export * from "./Partners.vue?vue&type=script&setup=true&lang=js"

import "./Partners.vue?vue&type=style&index=0&id=b6d5fc08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6d5fc08"]])

export default __exports__